import { PhoneMobileInputForm } from "@/features/auth/view/PhoneMobileInput/PhoneMobileInputForm";

export const PhoneMobileInputPage = () => {
  return <PhoneMobileInputForm />;
};
